import Vue from 'vue';
import VueApollo from 'vue-apollo';
import ApolloClient from 'apollo-client';

import { InMemoryCache } from 'apollo-cache-inmemory';
import { HttpLink } from 'apollo-link-http';

import { ApolloLink, concat } from 'apollo-link';
import Logging from '@/logging';

// Install the vue plugin
Vue.use(VueApollo);

// Name of the localStorage item
const AUTH_TOKEN = 'apollo_token';

// Http endpoint
const httpEndpoint = process.env.VUE_APP_GRAPHQL_HTTP || 'http://localhost:4000/graphql';
// Files URL root
export const filesRoot = process.env.VUE_APP_FILES_ROOT || httpEndpoint.substr(0, httpEndpoint.indexOf('/graphql'));

Vue.prototype.$filesRoot = filesRoot;

const authMiddleWare = new ApolloLink((operation, forward) => {
	const token = localStorage.getItem(AUTH_TOKEN);

	operation.setContext({
		headers: {
			authorization: token ? `Bearer ${token}` : ''
		}
	});

	return forward(operation);
});

const link = new HttpLink({
	uri: process.env.VUE_APP_GRAPHQL_HTTP
});

interface risoltoGraphqlObject {
    __typename?: string;
    reference?: string;
}

export const client = new ApolloClient({
	link: concat(authMiddleWare, link),
	cache: new InMemoryCache({
		dataIdFromObject(responseObject: risoltoGraphqlObject) {
			return `${responseObject.__typename}:${responseObject.reference}`;
		}
	}),
	defaultOptions: {
		watchQuery: {
			fetchPolicy: 'no-cache',
			errorPolicy: 'ignore'
		},
		query: {
			fetchPolicy: 'no-cache',
			errorPolicy: 'all'
		}
	}
});

// Call this in the Vue app file
export function createProvider() {
	const apolloProvider = new VueApollo({
		defaultClient: client
	});
	return apolloProvider;
}

// Manually call this when user log in
export async function onLogin(apolloClient, token) {
	if (typeof localStorage !== 'undefined' && token) {
		localStorage.setItem(AUTH_TOKEN, token);
	}
	// if (apolloClient.wsClient) restartWebsockets(apolloClient.wsClient);
	try {
		await apolloClient.resetStore();
	} catch (e) {
		Logging.error('%cError on cache reset (login)', 'color: orange;', e.message);
	}
}

// Manually call this when user log out
export async function onLogout(apolloClient) {
	if (typeof localStorage !== 'undefined') {
		localStorage.removeItem(AUTH_TOKEN);
	}
	// if (apolloClient.wsClient) restartWebsockets(apolloClient.wsClient);
	try {
		await apolloClient.resetStore();
	} catch (e) {
		Logging.error('%cError on cache reset (logout)', 'color: orange;', e.message);
	}
}
